<template>
    <div> <b-card no-body class="card-transparent-background h-100 my-0">
            <b-card-header class="card-title-garden-help-default pb-0 pl-1">Select Location on
                Map</b-card-header>
            <b-card-body class="h-100 pt-1 px-1">
                <p v-if="invalid_property_size" class="error_validation_message_p_gardenhelp">
                    Please mark the garden on the map using the drawing tool
                </p>
                <GmapMap :center="map_center" :zoom="map_zoom" map-type-id="hybrid"
                    class="job-map-container-garden-help h-100" ref="gmap" style="min-height: 600px" :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUi: false,
                    }">
                    <GmapMarker v-if="property_position != null" :position="property_position" :clickable="false"
                        :draggable="false" />
                    <!-- <gmap-polygon :paths="map_points.points" :options="{
                        fillColor: '#0068B8',
                        fillOpacity: 0.5,
                        strokeColor: '#0068B8',
                        strokeWeight: 3,
                        editable: false,
                    }" ref="polygon">
                    </gmap-polygon> -->
                </GmapMap>
            </b-card-body>
        </b-card></div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import { gmapApi } from "vue2-google-maps";



export default {
    name: "DrawMapProperty",
    components: {
    },
    props: ["map_zoom", "map_center", "property_position",
        "polygon_points","property_size",
        "invalid_property_size"],
    data() {
        return {

            google: gmapApi,
            polygon:null,
            map_points :{points:[]},
            polygonOptions: {
                fillColor: "#0068B8",
                fillOpacity: 0.5,
                strokeColor: "#0068B8",
                strokeWeight: 3,
                editable: true,
            },
            drawingManager: null,
        }
    },
    mounted() {
        this.initMap();
    },
    
  computed: {
    _polygon_points: {
      get() {
        return this.polygon_points;
      },
      set(value) {
        this.$emit("update:polygon_points", value);
      },
    },
    _property_size: {
      get() {
        return this.property_size;
      },
      set(value) {
        this.$emit("update:property_size", value);
      },
    },
},
    methods: {
        initMap() {
            let temp = this;

            setTimeout(function () {
                console.log(temp.$refs.gmap.$mapObject);
                temp.drawingManager = new google.maps.drawing.DrawingManager({
                    drawingMode: google.maps.drawing.OverlayType.POLYGON,
                    drawingControl: true,
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.TOP_LEFT,
                        drawingModes: [google.maps.drawing.OverlayType.POLYGON],
                    },
                    markerOptions: {
                        icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
                    },
                    polygonOptions: temp.polygonOptions
                });
                temp.drawingManager.setMap(temp.$refs.gmap.$mapObject);
                google.maps.event.addListener(
                    temp.drawingManager,
                    "overlaycomplete",
                    function (event) {
                        // Get overlay paths
                        console.log(event);
                        let paths = event.overlay.getPath().getArray();
                        console.log(paths);
                        var newShape = event.overlay;
                        newShape.type = event.type;
                        console.log("polyogn")
                        console.log(newShape)
                        // temp.$emit("update:polygon",JSON.parse(newShape));
                        temp.polygon = newShape; 
                        console.log(temp.calculatePolygonSize(event.overlay.getPath()));

                        // Disable drawingManager
                        temp.drawingManager.setDrawingMode(null);

                        // Create Polygon
                        // temp.savePolygon(paths);
                        console.log("----------------------------------------");
                        // overlayDragListener(event.overlay);
                        let overlay = event.overlay;
                        google.maps.event.addListener(
                            overlay.getPath(),
                            "set_at",
                            function (event) {
                                // $('#vertices').val(overlay.getPath().getArray());
                                console.log(overlay.getPath().getArray());
                                console.log(temp.calculatePolygonSize(overlay.getPath()));
                            }
                        );
                        google.maps.event.addListener(
                            overlay.getPath(),
                            "insert_at",
                            function (event) {
                                // $('#vertices').val(overlay.getPath().getArray());
                                console.log(overlay.getPath().getArray());
                                console.log(temp.calculatePolygonSize(overlay.getPath()));
                            }
                        );
                    }
                );
                google.maps.event.addListener(
                    temp.drawingManager,
                    "polygoncomplete",
                    function (polygon) {
                        console.log(polygon);
                    }
                );

                google.maps.event.addListener(
                    temp.drawingManager,
                    "drawingmode_changed",
                    function () {
                        if (temp.drawingManager.getDrawingMode() != null) {
                            temp.polygon.setMap(null);
                            temp.polygon = null;
                        }
                    }
                );

                // delete polygon
                //Add a custome control button
                let controlDiv = document.createElement("div");
                // Set CSS for the control border.
                const controlUI = document.createElement("div");
                controlUI.id = "eraser-polygon"
                controlUI.style.backgroundColor = "#fff";
                controlUI.style.border = "2px solid #fff";
                controlUI.style.borderRadius = "3px";
                controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
                controlUI.style.cursor = "pointer";
                controlUI.style.margin = "5px -4px";
                controlUI.style.height = "28px";
                controlUI.style.textAlign = "center";
                // controlUI.title = "Click to recenter the map";
                controlDiv.appendChild(controlUI);

                const controlText = document.createElement("div");
                controlText.style.color = "rgb(25,25,25)";
                controlText.style.fontFamily = "Roboto,Arial,sans-serif";
                controlText.style.fontSize = "16px";
                controlText.style.lineHeight = "16px";
                controlText.style.padding = "4px";
                controlText.innerHTML = '<i class="fas fa-eraser"></i>';

                controlUI.appendChild(controlText);
                // Setup the click event listeners: simply set the map to Chicago.
                controlUI.addEventListener("click", () => temp.deleteSelectedShape());

                temp.$refs.gmap.$mapObject.controls[
                    google.maps.ControlPosition.TOP_LEFT
                ].push(controlDiv);
            }, 1000);
        },
        deleteSelectedShape() {
            this.polygon.setMap(null);
            this.polygon = null;
        },
        calculatePolygonSize(path) {
            let size = google.maps.geometry.spherical.computeArea(path);
            console.log("size: " + size + " meters");
            console.log(path);
            this._property_size = Math.round(size * 100) / 100;
            // this.$emit("update:property_size", Math.round(size * 100) / 100);
            let path_arr = path.getArray(),
                points = [];
            for (let i = 0; i < path_arr.length; i++) {
                console.log("      ", path_arr[i].lat(), path_arr[i].lng());
                points.push({ lat: path_arr[i].lat(), lng: path_arr[i].lng() });
            }
            this.map_points = { points: points };
            this._polygon_points = this.map_points 
            console.log(points);
            console.log(this.map_points);

            return size;
        },
    }
}
</script>

<style scoped>
.gmnoprint div button {
    margin-right: 4px !important;
    border-radius: 3px !important;
}
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/customer/details_components/DrawMapProperty.vue